export enum ThemeSetting {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}

type VuetifyTheme = 'dark' | 'light';

export const getSystemTheme = (): VuetifyTheme => {
  return window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};

export const getCurrentTheme = (): VuetifyTheme => {
  const currentTheme = getCurrentThemeSetting();
  if (currentTheme === ThemeSetting.System) {
    return getSystemTheme();
  }
  return currentTheme === ThemeSetting.Dark ? 'dark' : 'light';
};

export const getCurrentThemeSetting = (): ThemeSetting => {
  const storedTheme = localStorage.getItem('theme');
  if (storedTheme) {
    return <ThemeSetting>storedTheme;
  }
  return ThemeSetting.System;
};

export const saveCurrentTheme = (theme: ThemeSetting) => {
  localStorage.setItem('theme', theme);
};
